// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bea_a bih_wl","LoadingPlaceholder":"bea_b bih_h","loading-placeholder":"bea_c"};